export const MODEL_AGENCY_AS_TYPE_MOTHER = 'mother';
export const MODEL_AGENCY_AS_TYPE_OTHER = 'other';
export const MODEL_AGENCY_AS_TYPE_REFUSED = 'refused';
export const MODEL_AGENCY_AS_TYPE_PROPOSAL = 'proposal';
export const MODEL_AGENCY_AS_TYPE_DROPPED_MOTHER = 'dropped_mother';
export const MODEL_AGENCY_AS_TYPE_DROPPED = 'dropped';
export const MODEL_AGENCY_AS_TYPE_LEFT = 'left';

export const MODEL_AGENCY_PROFIT_TYPE_GROSS = 'gross';
export const MODEL_AGENCY_PROFIT_TYPE_NET_FOR_MODEL = 'net_for_model';